/**
 * 目标类型
 */
import { Vue, Component } from 'vue-property-decorator';

@Component({})
export default class TargetDetailMixin extends Vue {

  // 项目目标
  private comicTargetName(target_type: number) {
    const that: any = this;
    let typeInfo;
    if (!that.attributeData.other_type) {
      return '';
    }
    typeInfo = that.attributeData.other_type[5].find((item: any) => item.value === target_type);
    return typeInfo ? typeInfo.label : '';
  }

  // 用户项目目标
  private userTargetName(target_type: number) {
    const that: any = this;
    let typeInfo;
    if (!that.attributeData.user_target) {
      return '';
    }
    typeInfo = that.attributeData.user_target.target_type.find((item: any) => item.id === target_type);
    return typeInfo ? typeInfo.name : '';
  }
}
